export default __webpack_public_path__ + "8acd6efeb409f81397b9956095a64aaa.svg";